export const faqData = [
  {
    question: "What exactly does YourWebsiteScore do?",
    answer:
      "We scan your website to find hidden issues hurting your rankings and visibility. You get a detailed report with exact fixes for every problem we detect—performance, security, SEO, and more.",
  },
  {
    question: "How do I fix the issues you find?",
    answer:
      "Every issue comes with a clear explanation and step-by-step fix. You can copy fix instructions directly to your clipboard or use our 'Copy to LLM' feature to paste them into ChatGPT or Claude for guided help.",
  },
  {
    question: "How many free analyses do I get?",
    answer:
      "Every account gets 3 free analyses. You'll see the overall scores for Performance, SEO, and Trust & Security—enough to understand where your site stands. Detailed breakdowns, individual checks, and actionable fixes are unlocked with a paid plan.",
  },
  {
    question: "Do I need to create an account?",
    answer:
      "Yes. Accounts are free and unlock your free trial analysis, saved history, and the ability to enable monitoring for your own domains.",
  },
  {
    question: "What plans are available right now?",
    answer:
      "Two simple options: $5/month if you prefer a subscription, or $35 one-time for Lifetime access. Both include every feature—no add-ons, upsells, or usage throttles.",
  },
  {
    question: "What's included in Lifetime access?",
    answer:
      "Unlimited analyses, automated daily monitoring (10 domains by default with higher limits available), certified report pages with do-follow backlinks, the embeddable score badge, historical tracking, alerts, and every future feature.",
  },
  {
    question: "How is this different from Google PageSpeed Insights?",
    answer:
      "PageSpeed shows metrics—we show you what's broken and how to fix it. We combine PageSpeed data with UX, SEO, and security checks, give you actionable fixes for every issue, and track your progress over time.",
  },
  {
    question: "How often do monitored domains refresh?",
    answer:
      "Every 24 hours. We rerun PageSpeed, refresh our proprietary checks, and update your certified report page automatically.",
  },
  {
    question: "How many domains can I monitor?",
    answer:
      "Lifetime and Monthly plans include monitoring for 10 domains by default. Need more? Reach out and we'll unlock additional capacity for your account.",
  },
  {
    question: "What does the Overall Score represent?",
    answer:
      "It's a balanced blend of Performance, Website Quality, and Trust & Security. Each pillar contributes equally so you can see a single health score at a glance.",
  },
  {
    question: "Is the performance badge really lightweight?",
    answer:
      "Yes. The badge loads asynchronously, is under 1KB, and has zero impact on your Core Web Vitals. It simply mirrors your latest certified score.",
  },
  {
    question: "Do I really get a backlink?",
    answer:
      "Absolutely. Every monitored domain receives a certified report page that links back to your site with a high-authority do-follow reference.",
  },
];

export const generateFaqSchema = () => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqData.map((item) => ({
    "@type": "Question",
    name: item.question,
    acceptedAnswer: {
      "@type": "Answer",
      text: item.answer,
    },
  })),
});
